function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "32",
  viewBox: "0 0 24 32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "happytrans",
  fill: "#FFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15.635 7.344L14.23 1.957a2.307 2.307 0 00-2.242-1.71 2.307 2.307 0 00-2.243 1.71L8.341 7.344h7.294zm1.674 6.423H6.667l.876-3.365h8.89l.876 3.365zm1.674 6.423H4.993l.063-.24.538-2.066.276-1.058h12.235l.878 3.364zm4.277 8.979c0 1.326-1.094 2.4-2.445 2.4H3.16c-1.35 0-2.446-1.074-2.446-2.4 0-1.325 1.095-2.4 2.446-2.4h.118l.918-3.52h15.583l.918 3.52h.118c1.351 0 2.446 1.075 2.446 2.4h-.001z",
  id: "Shape"
}))))));